import React from "react";
import DataTypeHelper from "../dataTypes/DataTypeHelper";

class DefaultRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.checked,
      header_lengths: this.props.header_lengths,
    };
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props && prevProps.checked !== this.props.checked) {
      this.setState({ checked: this.props.checked });
    }
    if (this.props && prevProps.header_lengths !== this.props.header_lengths) {
      this.setState({ header_lengths: this.props.header_lengths });
    }
  }

  render() {
    var self = this;
    var mergedProps = $.extend({}, self.props, self.state);
    var columns = this.props.headers.map(function (header, idx) {
      if ($(".modal-body")[0]) {
      } else if (
        self.state.header_lengths &&
        self.state.header_lengths.length > 0
      ) {
        if ($(`#${idx}`)[0] && self.state.header_lengths.length > 0) {
          if (self.state.header_lengths[idx] == $(`#${idx}`)[0].offsetWidth) {
            $(".table-wrapper")[0].style.visibility = "visible";
          }
        }
      }

      return (
        <td
          id={idx}
          className={`${header.data_type}DataType-td ${
            header.display_name ? header.display_name : header.column_name
          }-td`}
          key={header.column_name}
        >
          {DataTypeHelper.renderColumn(
            header.data_type,
            self.props.row[header.column_name],
            mergedProps,
            header
          )}
        </td>
      );
    });

    // do we have table actions? (and thus do we need checkboxes?)
    if (this.props.table_actions && this.props.table_actions.length > 0) {
      columns.unshift(
        <td key="checkbox_col" className=" col-checkbox">
          <input
            type="checkbox"
            value={
              this.props.row.id
                ? this.props.row.id
                : JSON.stringify(this.props.row.id_fields)
            }
            checked={this.state.checked}
            onChange={this.toggleCheckbox}
          />
        </td>
      );
    }

    if (this.props.row.upload_file_name) {
      return (
        <tr
          key={
            this.props.row.id
              ? this.props.row.id
              : JSON.stringify(this.props.row.id_fields)
          }
          className={this.state.checked ? "checked" : null}
          id={this.props.row.id}
          src={this.props.row.thumb_medium_url}
          original_url={this.props.row.original_url}
          upload_file_name={this.props.row.upload_file_name}
          upload_content_type={this.props.row.upload_content_type}
        >
          {columns}
        </tr>
      );
    } else {

      return (
        <tr
          key={this.getRowId(this.props.row)}
          className={this.state.checked ? "checked" : null}
        >
          {columns}
        </tr>
      );
    }
  }

  getRowId(row) {
    if(!row.id) {
      return this.generateId()
    } else if (typeof row.id !== "undefined" ) {
      return row.id
    } else {
      return JSON.stringify(row.id_fields)
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  toggleCheckbox() {
    var self = this;

    this.setState({ checked: this.state.checked ? false : true }, function () {
      if (typeof self.props.onToggleCheckbox == "function") {
        self.props.onToggleCheckbox(
          self.state.checked,
          self.props.row.id
            ? self.props.row.id
            : JSON.stringify(self.props.row.id_fields)
        );
      }
    });
  }
}

export default DefaultRow;
